<div class="wrapper page-heading page-heading-header-bg">
    <form [formGroup]="searchForm">
        <div class="row page-heading-left">
            <div class="col-xs-6">
                <h1 [i18n]="'df-management.df-transaction.title'"></h1>
            </div>
            <div>
                <img (click)="openPopup()"
                     alt="bellIcon" class="bellIconAlerts" src="assets/NotificationWhite.svg">
                <app-notification-alert *ngIf="isPopupVisible | async"
                                        [countryCode]="countryCode"></app-notification-alert>
            </div>
            <div class="col-xs-6">
                <div class="row">
                    <div class="col-xs-5">
                        <ng-select (change)="updateCountry($event)" formControlName="country"
                                   placeholder={{selectCountry}}>
                            <ng-option *ngFor="let column of countryData" [value]="column">
                                {{ column.country }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xs-7">
                        <ng-select (change)="updateCarrierId($event)" [clearSearchOnAdd]="true" [closeOnSelect]="false"
                                   [multiple]="true" [searchable]="true" [selectableGroupAsModel]="false"
                                   [selectableGroup]="true"
                                   bindLabel="carrier" formControlName="carrierId" groupBy="selectedAllGroup"
                                   placeholder={{selectCarrierID}}>
                            <ng-option *ngFor="let column of carriers" [value]="column">
                                {{ column.carrier }} - {{ column.carrier_code }}
                            </ng-option>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                                <input [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected"
                                       id="item-{{ index }}"
                                       type="checkbox"/>
                                Select All
                            </ng-template>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                <input [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected"
                                       id="item-{{ index }}"
                                       type="checkbox"/>
                                {{ item.carrier }} - {{ item.carrier_code }}
                            </ng-template>
                            <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
                                <div *ngFor="let item of items | slice: 0:1" class="ng-value">
                                    <span class="ng-value-label">{{ item.carrier }}</span>
                                    <span (click)="clear(item)" aria-hidden="true" class="ng-value-icon right">×</span>
                                </div>
                                <div *ngIf="items.length > 1" class="ng-value">
                                    <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<section class="chepfm--section__filters">
    <div class="col-xs-12">
        <form [formGroup]="searchForm" class="chepfm--filter__form">
            <div class="row">
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-transaction.filters.labels.search'"></label>
                        <div class="input-group">
                            <input *ngIf="countryCode !== 'USA'" [(ngModel)]="searchText"
                                   [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-transaction.filters.placeholder.search-for-result'}]"
                                   [ngModelOptions]="{standalone: true}" class="form-control">
                            <input *ngIf="countryCode === 'USA'" [(ngModel)]="searchText"
                                   [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-transaction.filters.placeholder.search-for-result-usa'}]"
                                   [ngModelOptions]="{standalone: true}" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-transaction.filters.labels.load-id'"></label>
                        <input
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-transaction.filters.placeholder.load-id'}]"
                            class="form-control"
                            formControlName="loadId"
                            type="text">
                    </div>
                </div>
                <div *ngIf="countryCode !== 'USA'" class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-transaction.filters.labels.assest-id'"></label>
                        <ng-select (change)="updateAsset($event)" formControlName="assetId"
                                   placeholder={{selectAssetID}}>
                            <ng-option *ngFor="let column of assets" [value]="column">
                                {{ column.asset_id }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div *ngIf="countryCode === 'USA'" class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-transaction.filters.labels.status'"></label>
                        <ng-select (change)="updateStatus($event)" formControlName="status"
                                   placeholder={{selectStatus}}>
                            <ng-option *ngFor="let column of filteredStatusList" [value]="column">
                                {{ column.status }} - {{ column.statusShortForm }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row search-filter">
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label *ngIf="countryCode !== 'USA'"
                               [i18n]="'df-management.df-transaction.filters.labels.start-date'"></label>
                        <label *ngIf="countryCode === 'USA'"
                               [i18n]="'df-management.df-transaction.filters.labels.shipped-start-date'"></label>
                        <input [dpDayPicker]="configDate" [theme]="'date-time-picker'"
                               class="form-control calender-icon"
                               formControlName="startDate" placeholder="YYYY-MM-DD">
                    </div>
                </div>
                <div class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label *ngIf="countryCode !== 'USA'"
                               [i18n]="'df-management.df-transaction.filters.labels.end-date'"></label>
                        <label *ngIf="countryCode === 'USA'"
                               [i18n]="'df-management.df-transaction.filters.labels.shipped-end-date'"></label>
                        <input [dpDayPicker]="config" [theme]="'date-time-picker'" class="form-control calender-icon"
                               formControlName="endDate" placeholder="YYYY-MM-DD">

                    </div>
                </div>
                <div *ngIf="countryCode !== 'USA'" class="col-md-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.df-transaction.filters.labels.status'"></label>
                        <ng-select (change)="updateStatus($event)" formControlName="status"
                                   placeholder={{selectStatus}}>
                            <ng-option *ngFor="let column of statusList" [value]="column">
                                {{ column.status }} - {{ column.statusShortForm }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-auto pull-left chepfm--filter__actions">
                    <a (click)="resetSearchData()">
                        <span><i aria-hidden="true" class="fa fa-ban repeat--icon"></i></span>&nbsp;
                        <span [i18n]="'df-management.df-transaction.filters.buttons.reset-button'"></span>
                    </a>
                </div>
                <div class="col-md-auto pull-right chepfm--filter__actions">
                    <button (click)="downloadAllTransactionReport()" [disabled]="isButtonDisabled" class="btn info">
                        <span [i18n]="'df-management.form.file.download-transaction-report'"></span>
                    </button>
                    <button (click)="applySearch('blueYounder')" [disabled]="isFetchButtonDisabled" class="btn info">
                        <span [i18n]="'df-management.df-transaction.filters.buttons.fetch-from-by'"></span>
                    </button>
                    <button (click)="applySearch('fleetManagement')" [disabled]="isFetchButtonDisabled"
                            class="btn btn-i btn-primary"
                            type="submit">
                        <span [i18n]="'df-management.df-transaction.filters.buttons.apply-button'"></span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</section>
<section *ngIf="isVisibleCards" class="chepfm--sections__cards-wrapper col-xs-12">
    <app-df-transaction-quick-filter
        (useQuickFilter)="filterNoOfLoads()"
        [asset]="'assets/trans-load.svg'"
        [count]="pageTransData?.total_loads_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.no-of-loads'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterCreatedData()"
        [asset]="'assets/trans-created.svg'"
        [count]="pageTransData?.created_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.created'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterAutomaticCharges()"
        [asset]="'assets/trans-system.svg'"
        [count]="pageTransData?.auto_calculated_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.updated-system'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterManualCharges()"
        [asset]="'assets/trans-count.svg'"
        [count]="pageTransData?.manually_calculated_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.user-count'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterSuccessData()"
        [asset]="'assets/trans-success.svg'"
        [count]="pageTransData?.success_count"
        [hasLargeIcon]="true"
        [labelKey]="'df-management.df-transaction.form.card-heading.success'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterFailureData()"
        [asset]="'assets/trans-failed.svg'"
        [count]="pageTransData?.failure_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.failures'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterNoContractData()"
        *ngIf="countryCode !== 'USA'"
        [asset]="'assets/plagiarism.svg'"
        [count]="pageTransData?.no_active_contract_count"
        [hasLargeIcon]="true"
        [labelKey]="'df-management.df-transaction.form.card-heading.noContracts'">
    </app-df-transaction-quick-filter>

    <app-df-transaction-quick-filter
        (useQuickFilter)="filterNotEligibleData()"
        [asset]="'assets/notEligibleicon.svg'"
        [count]="pageTransData?.not_eligible_count"
        [labelKey]="'df-management.df-transaction.form.card-heading.notEligible'">
    </app-df-transaction-quick-filter>
</section>

<section class="chepfm--section__actions">
    <div class="col-xs-12">
        <ng-container *ngIf="countryCode !== 'USA'">
            <div class="col-md-auto pull-left">
                <button (click)="updateCharge()" [disabled]="isEditButtonDisabled" class="btn info" type="button">
                        <span [i18n]="'df-management.df-transaction.form.buttons.update-charges'"></span>
                    </button>
            </div>
            <div class="col-md-auto pull-right">
                <button (click)="downloadFailureReport()" [disabled]="isButtonDisabled"
                        class="btn btn-i btn-primary"
                        type="button">
                    <i aria-hidden="true" class="fa fa-download">&nbsp;</i><span
                    [i18n]="'df-management.df-transaction.form.buttons.download-failure-report'"></span>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="countryCode === 'USA'">
            <div class="pull-left ">
                <app-dropdown-button [alignLeft]="true"
                                     [btnTextKey]="'df-management.df-transaction.form.buttons.mass-updates'"
                                     [large]="false">
                    <li app-dropdown-button-item>
                        <span (click)="updateCharge()"
                              [i18n]="'df-management.df-transaction.form.buttons.truck-rent-upload'"></span>
                    </li>
                    <li app-dropdown-button-item [ngClass]="{'disable_span': !canSendMilageDataForSelectedCharges}">
                        <span (click)="canSendMilageDataForSelectedCharges && bulkBtfSubmit()"
                              [ngClass]="{'disable_span': !canSendMilageDataForSelectedCharges}"
                              [i18n]="'df-management.df-transaction.form.buttons.btf-bulk-upload'"></span>
                    </li>
                </app-dropdown-button>
            </div>
            <div class="pull-right">
                <button (click)="downloadFailureReport()"
                        [disabled]="isButtonDisabled"
                        class="btn info btn-i"
                        type="button">
                    <i aria-hidden="true" class="fa fa-download">&nbsp;</i><span
                    [i18n]="'df-management.df-transaction.form.buttons.download-failure-report'"></span>
                </button>
                <button (click)="downloadTransactionData()"
                        [disabled]="isButtonDisabled"
                        class="btn info btn-i">
                    <i aria-hidden="true" class="fa fa-download">&nbsp;</i><span
                    [i18n]="'df-management.form.file.download-transaction-template'"></span>
                </button>
                <button (click)="selectDateScreen()"
                        [disabled]="isButtonDisabled"
                        class="btn btn-i btn-primary">
                    <i aria-hidden="true" class="fa fa-upload">&nbsp;</i><span
                    [i18n]="'df-management.form.file.upload-transaction-template'"></span>
                </button>
            </div>
        </ng-container>
    </div>
</section>

<section class="col-xs-12 summary-panel">

    <app-data-table (onLoad)="getTransactionData()"
                    [(filters)]="filters"
                    [columns]="columns"
                    [loadPage]="loadPage"
                    [showColumnsSelection]="false"
                    [sortColumn]="sortColumn">
    </app-data-table>

    <ng-template #checkboxColumn let-item="item">
        <div
            *ngIf="(countryCode !== 'USA' && item.loadStatusShortform === 'C')
            || item.loadStatusShortform === 'AC'
            || item.loadStatusShortform === 'MC'"
        >
            <div class="checkbox">
                <label>
                    <input (change)="onCheckboxChange($event.currentTarget.checked, item)"
                           type="checkbox">
                    <i [ngStyle]="{'background': item.selected === true ? '#0078bf' : 'white'}"
                       class="fa checkbox-icon"></i>
                </label>
            </div>
        </div>
    </ng-template>
    <ng-template #carrierCodeColumn let-carrierCode="carrierCode">
        <span>{{ carrierCode }}</span>
    </ng-template>
    <ng-template #assetIdColumn let-assetId="assetId">
        <span>{{ assetId }}</span>
    </ng-template>
    <ng-template #loadIdColumn let-loadId="loadId">
        <span>{{ loadId }}</span>
    </ng-template>
    <ng-template #shipmentIdColumn let-deliveryId="deliveryId">
        <ng-container *ngIf="shouldDisplayIcon(deliveryId)">
      <span [title]="getShipmentsString(deliveryId)" class="btn btn-secondary" data-bs-placement="top"
            data-bs-toggle="tooltip">
        {{ getSingleDeliveryId(deliveryId) }}
          <i class="fas fa-info-circle"></i>
      </span>
        </ng-container>
        {{ shouldDisplayIcon(deliveryId) ? '' : getShipmentsString(deliveryId) }}
    </ng-template>
    <ng-template #originIdColumn let-originId="originId">
        <span>{{ originId }}</span>
    </ng-template>
    <ng-template #destinationIdColumn let-destinationId="destinationId">
        <span>{{ destinationId }}</span>
    </ng-template>
    <ng-template #pgiDateColumn let-pgiDate="pgiDate">
        <span>{{ (pgiDate | date: 'MM/dd/yyyy':'UTC') }}</span>
    </ng-template>
    <ng-template #shippedDateColumn let-actualPickupDate="actualPickupDate">
        <span>{{ (actualPickupDate | date: 'MM/dd/yyyy':'UTC') }}</span>
    </ng-template>
    <ng-template #loadedMilesColumn let-loadedMiles="loadedMiles">
        <span>{{ loadedMiles }}</span>
    </ng-template>
    <ng-template #emptyMilesColumn let-emptyMiles="emptyMiles">
        <span>{{ emptyMiles }}</span>
    </ng-template>
    <ng-template #btfStatusColumn let-btfStatus="btfStatus">
        <i *ngIf="btfStatus == BtfExportStatus.PENDING" class="fa fa-clock"></i>
        <i *ngIf="btfStatus == BtfExportStatus.DONE" class="fa fa-check-circle" style="color: #00A907"></i>
    </ng-template>
    <ng-template #totalChargesColumn let-totalCharges="totalCharges">
        <span>{{ totalCharges }}</span>
    </ng-template>
    <ng-template #statusColumn let-byStatusMessage="byStatusMessage" let-loadStatusShortform="loadStatusShortform">
        <span>{{ loadStatusShortform }}
            <span *ngIf="loadStatusShortform === 'NE'">
                <i aria-hidden="true" class="fa fa-info-circle" title="{{ byStatusMessage }}"></i>
            </span>
        </span>
    </ng-template>
    <ng-template #actionsColumn let-item="item">
        <div class="chepfm--table__actions">
            <button (click)="onEditClick(item)" [disabled]="isEditButtonDisabled" class="btn btn-info btn-sm"
                    type="button">
                <i aria-hidden="true" class="fa fa-caret-right vert-align-top"></i></button>
        </div>
    </ng-template>
</section>

<div *ngIf="isVisible" class="overlay-form">
    <div class="chepfm--form__collapse-show chepfm--form__collapse-wrapper">
        <div class="chepfm--form__collapse-header">
            <h3 *ngIf="countryCode !== 'USA'"
                [i18n]="'df-management.df-transaction.form.form-headings.assest-details'"
                class="chepfm--form__collapse-heading"></h3>
            <h3 *ngIf="countryCode === 'USA'"
                [i18n]="'df-management.df-transaction.form.form-headings.details'"
                class="chepfm--form__collapse-heading"></h3>
            <div class="chepfm--form__collapse-headeractions">
                <button (click)="openJsonInEditor(editTransactionData)" class="btn btn-white m-r-sm" type="button"><i
                    aria-hidden="true" class="fa fa-external-link-alt m-r-xs rotate"></i>
                    <span [i18n]="'df-management.df-transaction.form.form-headings.event-input'"></span>
                </button>
                <button (click)="openJsonInEditor(editTransactionData)" class="btn btn-white" type="button"><i
                    aria-hidden="true" class="fa fa-external-link-alt m-r-xs"></i>
                    <span [i18n]="'df-management.df-transaction.form.form-headings.event-output'"></span>
                </button>
                <div class="close-icon">
                    <button (click)="onCloseClick()" class="btn btn-link" type="button">
                        <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="chepfm--form__collapse-contain ">
            <form [formGroup]="dedicatedFleetTransactionForm" class="chepfm--form">
                <div class="row row-space">
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.load-id'" class="title"></div>
                            <div class="desc">{{ editTransactionData?.loadId || '-' }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.voucher-id'"
                                 class="title"></div>
                            <div class="desc">{{ editTransactionData?.voucherId || '-' }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.service-id'"
                                 class="title"></div>
                            <div class="desc">{{ editTransactionData?.serviceId || '-' }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.pieces'" class="title"></div>
                            <div class="desc">{{ editTransactionData?.pieces || '-' }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.load-start-date'"
                                 class="title"></div>
                            <div
                                class="desc">{{ (editTransactionData?.loadStartDate | date: 'yyyy-MM-dd':'UTC') || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.load-end-date'"
                                 class="title"></div>
                            <div
                                class="desc">{{ (editTransactionData?.loadEndDate | date: 'yyyy-MM-dd':'UTC') || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.pod-date'"
                                 class="title"></div>
                            <div class="desc">{{ (editTransactionData?.podDate | date: 'yyyy-MM-dd':'UTC') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.pod-status'"
                                 class="title"></div>
                            <div class="desc">{{ (editTransactionData?.podStatus) || '-' }}</div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.table-headings.status'" class="title"></div>
                            <div class="desc">
                            <span
                                *ngIf="editTransactionData?.loadStatus"
                                [ngClass]="{'chepfm--badge chepfm--badge__danger': (editTransactionData?.loadStatusShortform === 'F' || editTransactionData?.loadStatusShortform === 'UL' || editTransactionData?.loadStatusShortform === 'NE'), 'chepfm--badge chepfm--badge__success': (editTransactionData?.loadStatusShortform !== 'F' || editTransactionData?.loadStatusShortform !== 'UL') }">
                                {{ (editTransactionData?.loadStatus) || '-' }}
                                <span
                                    *ngIf="(editTransactionData?.loadStatusShortform === 'F' || editTransactionData?.loadStatusShortform === 'UL' || editTransactionData?.loadStatusShortform === 'NE')">
                                    <i aria-hidden="true" class="fa fa-info-circle fa-x"
                                       title="{{(editTransactionData?.byStatusMessage) || '-'}}"></i>
                                </span>
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.actual-date'"
                                 class="title"></div>
                            <div
                                class="desc">{{ (editTransactionData?.actualPickupDate | date: 'yyyy-MM-dd':'UTC') || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.total-distance'"
                                 class="title"></div>
                            <div class="desc">{{ editTransactionData?.distanceTravel || '-' }}</div>
                        </div>
                    </div>
                    <div *ngIf="countryCode === 'USA'" class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div class="title">BTF status</div>
                            <div [ngSwitch]="editTransactionData?.btfStatus" class="desc">
                                <span *ngSwitchCase="BtfExportStatus.PENDING"
                                      [i18n]="'df-management.df-transaction.form.btf-status.pending'"
                                      class="chepfm--badge chepfm--badge__warning"
                                ></span>
                                <span *ngSwitchCase="BtfExportStatus.DONE"
                                      [i18n]="'df-management.df-transaction.form.btf-status.done'"
                                      class="chepfm--badge chepfm--badge__success"
                                ></span>
                                <span *ngSwitchDefault>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <div class="details">
                            <div [i18n]="'df-management.df-transaction.form.form-headings.shipmentIds'"
                                 class="title"></div>
                            <div [ngClass]="{'desc': isSingleDeliveryId(), 'multipleIds': isMultipleDeliveryIds()}">
                                {{ formatDeliveryIds() }}
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <div class="row">

                    <div class="col-xs-12">
                        <h3 [i18n]="'df-management.df-transaction.form.form-headings.charge-details'"
                            class="chepfm--form__collapse-heading"></h3>
                    </div>

                    <div class="col-xs-12">
                        <h4 class="chepfm--form__collapse-heading">
                            <span [i18n]="'df-management.df-transaction.form.form-headings.fixed-charges'"></span>
                            &nbsp;<span style="color: red">(<span
                            [i18n]="'df-management.df-transaction.form.form-headings.mandatory'"></span>)</span>
                        </h4>
                    </div>
                    <div class="col-xs-6">
                        <label *ngIf="editTransactionData.countryCode === 'USA'"
                               [i18n]="'df-management.form.name.truck-rent-charges'"></label>
                        <label *ngIf="fixedFrequencyCharge  === 'Daily' && editTransactionData.countryCode !== 'USA'"
                               [i18n]="'df-management.form.name.contracted-truck-rent-charges'"></label>
                        <label *ngIf="fixedFrequencyCharge === 'Weekly'"
                               [i18n]="'df-management.df-transaction.form.form-headings.weekly-truck-rent'"></label>
                        <label *ngIf="fixedFrequencyCharge === 'Monthly'"
                               [i18n]="'df-management.df-transaction.form.form-headings.monthly-truck-rent'"></label>
                        <input
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
                            [readonly]="editTransactionData.loadStatusShortform === 'S' || editTransactionData.loadStatusShortform === 'UL' || isDisabledRentCharge "
                            class="form-control"
                            formControlName="truckRentCharges"
                            type="text"
                            validateNumber="9.3">
                        <span *ngIf="(dedicatedFleetTransactionForm.get('truckRentCharges').touched
                                        || dedicatedFleetTransactionForm.get('truckRentCharges').dirty)
                                      && dedicatedFleetTransactionForm.get('truckRentCharges').errors"
                              [i18n]="'df-management.form.message.error-message'"
                              class="errormsg"></span>
                    </div>

                    <ng-container *ngIf="editTransactionData.loadingCharges?.length">
                        <div class="col-xs-12">
                            <h4 class="chepfm&#45;&#45;form__collapse-heading">
                                <span
                                    [i18n]="'df-management.df-transaction.form.form-headings.variable-charges'"></span>
                                &nbsp;<span style="color: red">(<span
                                [i18n]="'df-management.df-transaction.form.form-headings.optional'"></span>)</span>
                            </h4>
                        </div>
                        <div *ngFor="let item of  dedicatedFleetTransactionForm?.get('amount')['controls']"
                             class="col-xs-6">
                            <label>{{ item?.value.charge_code }}</label>
                            <input [formControl]="item.get('charge_amount')"
                                   [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
                                   [readonly]="editTransactionData.loadStatusShortform === 'S' || editTransactionData.loadStatusShortform === 'UL' || isDisabledRentCharge"
                                   class="form-control"
                                   type="text"
                                   validateNumber="9.3">
                            <span
                                *ngIf="(item.get('charge_amount').touched || item.get('charge_amount').dirty) && item.get('charge_amount').errors"
                                [i18n]="'df-management.form.message.error-message'"
                                class="errormsg"></span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="editTransactionData.loadStatus !== 'Created'">
                        <div class="col-xs-12">
                            <h4 [i18n]="'df-management.df-transaction.form.form-headings.manual-charge-details'"
                                class="chepfm--form__collapse-heading">
                            </h4>
                        </div>
                        <div class="col-xs-6">
                            <label *ngIf="countryCode !== 'USA'"
                                   [i18n]="'df-management.df-transaction.form.form-headings.total-amount'"></label>
                            <label *ngIf="countryCode === 'USA'"
                                   [i18n]="'df-management.df-transaction.form.form-headings.truck-rent'"></label>
                            <input
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
                                [readonly]="editTransactionData.loadStatusShortform === 'S' || editTransactionData.loadStatusShortform === 'UL'"
                                class="form-control"
                                formControlName="totalManualAmount"
                                type="text"
                                validateNumber="9.3">
                            <span *ngIf="(dedicatedFleetTransactionForm.get('totalManualAmount').touched || dedicatedFleetTransactionForm.get('totalManualAmount').dirty)
                            && dedicatedFleetTransactionForm.get('totalManualAmount').errors"
                                  class="errormsg">
                    <span [i18n]="'df-management.form.message.error-message'"></span>
                </span>
                        </div>
                        <div class="col-xs-6">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.remarks'"></label>
                            <input
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.remarks-message'}]"
                                [readonly]="editTransactionData.loadStatusShortform === 'S' || editTransactionData.loadStatusShortform === 'UL'"
                                class="form-control"
                                formControlName="remarks"
                                type="text">
                        </div>
                    </ng-container>

                    <div class="col-xs-12 chepfm--submit_by">
                        <a (click)="submitTransactionData(TransactionDataAction.SUBMIT)"
                           [i18n]="'df-management.df-transaction.form.buttons.submit-button'"
                           [ngClass]="{'disable_link': isSubmitToBYDisabled() || isTransactionInProgress}"
                           class="link-danger">
                        </a>
                        <a (debounceClick)="submitSupressChargeData()"
                           [i18n]="'df-management.df-transaction.form.buttons.supressChargeButton'"
                           [ngClass]="{'disable_link': isSuppressChargeDisabled()}"
                           appDebounceClick
                           class="link-danger">
                        </a>
                    </div>
                </div>

                <ng-container *ngIf="countryCode === 'USA'">
                    <hr/>
                    <div class="row">

                        <div class="col-xs-12">
                            <h3 class="chepfm--form__collapse-heading">
                                <span
                                    [i18n]="'df-management.df-transaction.form.form-headings.mileage-details'"></span>
                                &nbsp;<span style="color: red">(<span
                                [i18n]="'df-management.df-transaction.form.form-headings.mandatory'"></span>)</span>
                            </h3>
                        </div>
                        <div class="col-xs-6">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.loaded-miles'"></label>
                            <input
                                [readonly]="editTransactionData.loadStatusShortform === 'UL' || editTransactionData.btfStatus === BtfExportStatus.DONE"
                                class="form-control"
                                formControlName="loadedMiles"
                                type="text"
                                validateNumber="9.3">
                        </div>
                        <div class="col-xs-6">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.empty-miles'"></label>
                            <input
                                [readonly]="editTransactionData.loadStatusShortform === 'UL' || editTransactionData.btfStatus === BtfExportStatus.DONE"
                                class="form-control"
                                formControlName="emptyMiles"
                                type="text"
                                validateNumber="9.3">
                        </div>
                        <div class="col-xs-12 chepfm--submit_by">
                            <a (click)="submitToBTF()"
                               [i18n]="'df-management.df-transaction.form.buttons.btf-submit-button'"
                               [ngClass]="{'disable_link': isTransactionInProgress || !canSubmitToBTF()}"
                               class="link-danger">
                            </a>
                        </div>
                    </div>
                </ng-container>

                <div class="row">
                <div class="col-xs-12 chepfm--form__actions">
                    <button (debounceClick)="saveTransactionData(TransactionDataAction.SAVE)"
                            [disabled]="disabledSaveTransactionData()"
                            appDebounceClick
                            class="btn btn-i btn-primary pull-right"
                            type="submit">
                        <span [i18n]="'df-management.df-transaction.form.buttons.save-button'"></span>
                    </button>&nbsp;&nbsp;
                </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="isVisibleCharges" class="overlay-form">
    <div [ngClass]="isVisibleCharges ? 'chepfm--form__collapse-show' : 'chepfm--form__collapse-hide'"
         class="chepfm--form__collapse-wrapper">
        <div class="chepfm--form__collapse-header">
            <h6 [i18n]="'df-management.df-transaction.form.form-headings.bulk-upload-charges'"
                class="chepfm--form__collapse-heading"></h6>
            <div class="close-icon">
                <button (click)="onCloseEvent()" class="btn btn-link" type="button">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
        </div>
        <div class="chepfm--form__collapse-contain">
            <form [formGroup]="updateChargesDataForm" class="chepfm--form">
                <div class="row">
                    <div class="col-xs-6">
                        <ng-container *ngIf="countryCode != 'USA'">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.enter-amount'"></label>
                            <input
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
                                class="form-control"
                                formControlName="totalCharges"
                                type="text"
                                validateNumber="9.3"
                            >
                        </ng-container>
                        <ng-container *ngIf="countryCode == 'USA'">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.enter-truck-rent'"></label>
                            <input
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.mass-update-truck-rent'}]"
                                class="form-control"
                                formControlName="totalCharges"
                                type="text"
                                validateNumber="9.3"
                            >
                        </ng-container>
                        <span
                            *ngIf="(updateChargesDataForm.get('totalCharges').touched || updateChargesDataForm.get('totalCharges').dirty) && updateChargesDataForm.get('totalCharges').errors"
                            class="errormsg">
                            <span [i18n]="'df-management.form.message.error-message'"></span>
                        </span>
                    </div>
                </div>&nbsp;&nbsp;
                <div class="icon-content">
                <span>
                    <i aria-hidden="true" class="fa fa-info-circle fa-x updateCharges-icon"></i><h6
                    [i18n]="'df-management.df-transaction.form.form-headings.charges-content'"
                    class="heading-content"></h6>
                </span>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="data-filter mb-3">
                            <label [i18n]="'df-management.df-transaction.form.form-headings.remarks'"></label>
                            <textarea class="form-control" formControlName="updatedTotalChargesNote"
                                      id="exampleFormControlTextarea1" rows="6"></textarea>
                        </div>
                    </div>
                </div>
                <div class="chepfm--filter__actions">
                    <button (click)="cancelCharges()" class="btn btn-i btn-primary">
                        <span [i18n]="'df-management.df-transaction.form.buttons.cancel'"></span>
                    </button>
                    <button (debounceClick)="showConfirmationPopup()" appDebounceClick class="btn btn-i btn-primary">
                        <span [i18n]="'df-management.df-transaction.form.buttons.update'"></span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="isPopupModel" class="overlay">
    <div class="popup-confirmation">
        <h4 [i18n]="'df-management.df-transaction.form.model-popup.save-content.heading'"
            class="confirmationheading"></h4>
        <div class="content">
            <span [i18n]="'df-management.df-transaction.form.model-popup.save-content.content'"></span>
        </div>&nbsp;
        <div class="row">
            <button (click)="cancelData()" class="btn btn-md info  confirmationCancel">
                <span [i18n]="'df-management.df-transaction.form.model-popup.save-content.cancel-button'"></span>
            </button>&nbsp;
            <button (debounceClick)="confirmData()" appDebounceClick
                    class="btn btn-i btn-primary btn-md pull-right confirmationSubmit"
                    type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.save-content.confirm-button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="bySubmitSuccessPopup" class="overlay">
    <div class="submit-popup">
        <div *ngIf="countryCode === 'USA'" class="submit-content">
            <i class="fa fa-check-circle success-button"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.by-submission-success.heading'"></h4>

            <span [i18n]="'df-management.df-transaction.form.model-popup.by-submission-success.content'"></span>
        </div>
        <div *ngIf="countryCode !== 'USA'" class="submit-content">
            <i class="fa fa-check-circle success-button"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.submit-content.heading'"></h4>

            <span [i18n]="'df-management.df-transaction.form.model-popup.submit-content.content'"></span>
        </div>
        <div class="form-group ">
            <button (click)="submitConfirm()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.submit-content.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="btfSubmitSuccessPopup" class="overlay">
    <div class="submit-popup">
        <div class="submit-content">
            <i class="fa fa-check-circle success-button"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.btf-submission-success.heading'"></h4>

            <span [i18n]="'df-management.df-transaction.form.model-popup.btf-submission-success.content'"></span>
        </div>
        <div class="form-group ">
            <button (click)="submitConfirm()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.btf-submission-success.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupUpdateModel" class="overlay">
    <div class="popup-confirmation">
        <h4 [i18n]="'df-management.df-transaction.form.model-popup.update-content.heading'"
            class="confirmationheading"></h4>
        <div class="content">
            <span *ngIf="countryCode != 'USA'"
                  [i18n]="'df-management.df-transaction.form.model-popup.update-content.content'"></span><br>
            <span *ngIf="countryCode == 'USA'"
                  [i18n]="'df-management.df-transaction.form.model-popup.update-content.alternate-content'"></span><br>
            <span [i18n]="'df-management.df-transaction.form.model-popup.update-content.sub-content'"></span>
        </div>&nbsp;
        <div class="row">
            <button (click)="cancelUpdateData()" class="btn btn-md info confirmationCancel">
                <span [i18n]="'df-management.df-transaction.form.model-popup.save-content.cancel-button'"></span>
            </button>&nbsp;
            <button (click)="confirmUpdateData()" class="btn btn-i btn-primary btn-md pull-right confirmationSubmit"
                    type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.save-content.confirm-button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupChargesUpdatedModel" class="overlay">
    <div class="sucesspopup">
        <div class="content">
            <i class="fa fa-check-circle success-btn"></i>
            <h4 [i18n]="'df-management.form.model-popup.heading'"></h4>
            <span [i18n]="'df-management.df-admin.popupModal.charge-content'"></span>
        </div>
        <div class="form-group">
            <button (click)="confirmChargesData()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="!isCheckboxSelected && isErrorPopup" class="overlay">
    <div class="errorpopup">
        <i class="fas fa-exclamation-circle charges-icon"></i>
        <h4 [i18n]="'df-management.df-transaction.form.model-popup.error-content.warning'" class="errorHeading"></h4>
        <div class="errorSubcontent">
            <span [i18n]="'df-management.df-transaction.form.model-popup.error-content.error-sub-content'"></span>
        </div>
        <div>
            <button (click)="confirmErrorData()" class="btn btn-i btn-primary btn-lg errorbtn" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupChargesErrorModel" class="overlay">
    <div class="errorMessage">
        <div class="content">
            <i class="fa fa-times-circle error-btn"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.error-content.error-heading'"
                class="errorMessageHeading"></h4>
            <span [i18n]="'df-management.df-transaction.form.model-popup.error-content.sub-errorContent'"></span>
        </div>
        <div class="form-group">
            <button (click)="confirmSameChargesError()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupCarrierChargesErrorModel" class="overlay">
    <div class="errorMessage">
        <div class="content">
            <i class="fa fa-times-circle error-btn"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.error-content.error-heading'"
                class="errorMessageHeading"></h4>
            <span
                [i18n]="'df-management.df-transaction.form.model-popup.error-content.sub-errorContent-carrier'"></span>
        </div>
        <div class="form-group">
            <button (click)="confirmSameCarrierChargesError()" class="btn btn-i btn-primary btn-lg button"
                    type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isdateSelected" class="overlay">
    <div class="dateSelection">
        <div class="dateSelectionContent">
            <span [i18n]="'df-management.df-transaction.form.form-headings.select-range'"
                  class="dateSelectionContent"></span>
            <div class="close-icon dateSelectionCloseIcon">
                <button (click)="onCloseIcon()" class="btn btn-link" type="button">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
            <div class="row">
                <form [formGroup]="dateAndTimeForm" class="dateBox">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-transaction.filters.labels.from-date'"
                                   class="dateAlignment"></label>
                            <div class="input-icons">
                                <input [dpDayPicker]="configDatetime" [theme]="'date-time-picker'"
                                       class="form-control calender-icon" formControlName="fromDate"
                                       placeholder="-select-">
                                <span *ngIf="dateErrorMsg" class="date-picker-errormsg">
                        <span [i18n]="'df-management.form.message.start-date-message'"></span>
                    </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-transaction.filters.labels.to-date'"
                                   class="dateAlignment"></label>
                            <div class="input-icons">
                                <input [dpDayPicker]="configDatetime" [theme]="'date-time-picker'"
                                       class="form-control calender-icon" formControlName="toDate"
                                       placeholder="-select-">
                                <span *ngIf="dateErrorMsg" class="date-picker-errormsg">
                            <span [i18n]="'df-management.form.message.end-date-message'"></span>
                        </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label [i18n]="'df-management.df-transaction.filters.labels.carrier-ids'"
                                   class="dateAlignment"></label>
                            <ng-select (change)="updateCarrierId($event)" [clearSearchOnAdd]="true"
                                       [closeOnSelect]="false"
                                       [multiple]="true" [searchable]="true" [selectableGroupAsModel]="false"
                                       [selectableGroup]="true"
                                       bindLabel="carrier" formControlName="selectCarriers"
                                       groupBy="selectedAllGroup"
                                       placeholder={{selectCarrierID}}>
                                <ng-option *ngFor="let column of carriers" [value]="column">
                                    {{ column.carrier }} - {{ column.carrier_code }}
                                </ng-option>
                                <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                                    <input [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected"
                                           class="select-all"
                                           id="item-{{ index }}" type="checkbox"/>
                                    Select All
                                </ng-template>
                                <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                    <input [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected"
                                           id="item-{{ index }}"
                                           type="checkbox"/>
                                    {{ item.carrier }} - {{ item.carrier_code }}
                                </ng-template>
                                <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
                                    <div *ngFor="let item of items | slice: 0:1" class="ng-value">
                                        <span class="ng-value-label">{{ item.carrier }}</span>
                                        <span (click)="clear(item)" aria-hidden="true"
                                              class="ng-value-icon right">×</span>
                                    </div>
                                    <div *ngIf="items.length > 1" class="ng-value">
                                        <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="form-group ">
            <app-df-transaction-file-upload
                (onFileAdded)="uploadTransactionDataFile($event)"
                [acceptedFileExtensions]="acceptedFileExtensions"
                [labelKey]="'df-management.df-transaction.form.model-popup.submit-content.button'" class="btn btn-i">
            </app-df-transaction-file-upload>
        </div>
    </div>
</div>

<div *ngIf="isFileUploadingPopupModel" class="overlay">
    <div class="errorpopup">
        <i class="fas fa-exclamation-circle charges-icon"></i>
        <h4 [i18n]="'df-management.df-transaction.form.model-popup.upload-file.upload-file-title'"
            class="errorHeading"></h4>
        <div class="fileSubcontent">
            <span [i18n]="'df-management.df-transaction.form.model-popup.upload-file.upload-file-content'"></span>
        </div>
    </div>
</div>

<div *ngIf="isReportDownloaded" class="overlay">
    <div class="reportDownload-popup">
        <div class="subForm">
            <i class="fas fa-exclamation-circle report-icon"></i>
            <div class="close-icon reportClose">
                <button (click)="onCloseReport()" class="btn btn-link" type="button">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
            <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.main-heading'"
                  class="subForm-content"></span><br>
            <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.sub-heading'"
                  class="subForm-subcontent"></span>
            <div class="row" class="top-align">
                <div class="col-sm-4">
                    <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.excel-record'"
                          class="excelRecords"></span>
                    &nbsp;<span class="excelRecords">{{ countOfRecordsInExcel }}</span>
                </div>
                <div class="col-sm-4">
                    <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-record'"
                          class="cmaRecords"></span>
                    &nbsp;<span class="cmaRecords">{{ countOfRecordsInCMA }}</span>
                </div>
                <div class="col-sm-4">
                    <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.error-record'"
                          class="errorRecords"></span>
                    &nbsp;<span class="errorRecords">{{ countOfErrorRecords }}</span>
                </div>
            </div>
        </div>

        <table *ngIf="countryCode === 'USA'" class="uploadError">
            <thead>
            <tr>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.carrierId'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.load-id'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.truck-rent'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.loaded-miles'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.empty-miles'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.status'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.btf-status'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-2 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.notes'"
                         class="row side-alignment"></div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let result of failureResultList">
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaCarrierCode || '-' }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelCarrierCode || '-' }}</div>
                    </div>
                </td>
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaLoadId || '-' }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelLoadId || '-' }}</div>
                    </div>
                </td>
                <td class="col-sm-1">{{ result.totalCharges || '-' }}</td>
                <td class="col-sm-1">{{ result.loadedMiles || '-' }}</td>
                <td class="col-sm-1">{{ result.emptyMiles || '-' }}</td>
                <td class="col-sm-1">{{ result.status || '-' }}</td>
                <td class="col-sm-1">{{ result.btfStatus || '-' }}</td>
                <td [ngClass]="{'chepfm--badge-color chepfm--badge-color__danger': (result['note'] !== 'SUCCEED' ), 'chepfm--badge-color chepfm--badge-color__success': (result['note'] === 'SUCCEED') }"
                    class="col-sm-2">
                    {{ result.note || '-' }}
                </td>
            </tr>
            </tbody>
        </table>

        <table *ngIf="countryCode !== 'USA'" class="uploadError">
            <thead>
            <tr>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.carrierId'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.load-id'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-2 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.total-charges'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.status'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-3 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.notes'"
                         class="row side-alignment"></div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let result of failureResultList">
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaCarrierCode || '-' }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelCarrierCode || '-' }}</div>
                    </div>
                </td>
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaLoadId || '-' }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelLoadId || '-' }}</div>
                    </div>
                </td>
                <td class="col-sm-2">{{ result.totalCharges || '-' }}</td>
                <td class="col-sm-1">{{ result.status || '-' }}</td>
                <td [ngClass]="{'chepfm--badge-color chepfm--badge-color__danger': (result['note'] !== 'SUCCEED' ), 'chepfm--badge-color chepfm--badge-color__success': (result['note'] === 'SUCCEED') }"
                    class="col-sm-3">
                    {{ result.note || '-' }}
                </td>
            </tr>
            </tbody>
        </table>

        <div class="form-group">
            <button (click)="downloadErrorPopup()" class="btn btn-i btn-primary btn-lg button errorReportButton"
                    type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.download-report'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="issuccessReportDownloaded" class="overlay">
    <div class="reportDownload-popup">
        <div class="subSuccessForm">
            <i class="fa fa-check-circle checked-icon"></i>
            <div class="close-icon reportClose">
                <button (click)="onCloseSucessReport()" class="btn btn-link" type="button">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
            <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.success'"
                  class="success-message"></span><br>
            <span class="success-content">{{ countOfRecordsInExcel }} out of {{ countOfRecordsInExcel }} are sucessfully updated.</span>
        </div>

        <table *ngIf="countryCode === 'USA'" class="uploadError">
            <thead>
            <tr>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.carrierId'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.load-id'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.truck-rent'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.loaded-miles'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.empty-miles'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.status'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.btf-status'"
                         class="row side-alignment"
                    ></div>
                </th>
                <th class="col-sm-2 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.notes'"
                         class="row side-alignment"></div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let result of successResultList">
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaCarrierCode }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelCarrierCode }}</div>
                    </div>
                </td>
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaLoadId }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelLoadId }}</div>
                    </div>
                </td>
                <td class="col-sm-2">{{ result.totalCharges }}</td>
                <td class="col-sm-2">{{ result.loadedMiles }}</td>
                <td class="col-sm-2">{{ result.emptyMiles }}</td>
                <td class="col-sm-1">{{ result.status }}</td>
                <td class="col-sm-1">{{ result.btfStatus }}</td>
                <td [ngClass]="{'chepfm--badge-color chepfm--badge-color__success': (result['note'] === 'SUCCEED') }"
                    class="col-sm-3">
                    {{ result.note }}
                </td>
            </tr>
            </tbody>
        </table>
        <table *ngIf="countryCode !== 'USA'" class="uploadError">
            <thead>
            <tr>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.carrierId'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-3">
                    <div class="row custom-row">
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.load-id'"
                             class="col-sm-12 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.cma-data'"
                             class="col-sm-6 headingPart"></div>
                        <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.uploaded-data'"
                             class="col-sm-6 headingPart"></div>
                    </div>
                </th>
                <th class="col-sm-2 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.total-charges'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-1 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.status'"
                         class="row side-alignment"></div>
                </th>
                <th class="col-sm-3 h-100 headingPart">
                    <div [i18n]="'df-management.df-transaction.form.model-popup.download-report.notes'"
                         class="row side-alignment"></div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let result of successResultList">
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaCarrierCode }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelCarrierCode }}</div>
                    </div>
                </td>
                <td class="col-sm-3">
                    <div class="row custom-row">
                        <div class="col-sm-6 cmaData">{{ result.cmaLoadId }}</div>
                        <div class="col-sm-6 uploadedData">{{ result.excelLoadId }}</div>
                    </div>
                </td>
                <td class="col-sm-2">{{ result.totalCharges }}</td>
                <td class="col-sm-1">{{ result.status }}</td>
                <td [ngClass]="{'chepfm--badge-color chepfm--badge-color__success': (result['note'] === 'SUCCEED') }"
                    class="col-sm-3">
                    {{ result.note }}
                </td>
            </tr>
            </tbody>
        </table>

        <div class="form-group">
            <button (click)="downloadSuccessPopup()" class="btn btn-i btn-primary btn-lg button errorReportButton"
                    type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.download-report.download-report'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupDownloadModel" class="overlay">
    <div class="download-popup">
        <i class="fa fa-check-circle download-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
        <div class="content">
            <span
                [i18n]="'df-management.df-transaction.form.model-popup.down-load-button.download-template-message'"></span>
        </div>
        <div class="form-group ">
            <button (click)="confirmDownload()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupTransactionReportModel" class="overlay">
    <div class="download-popup">
        <i class="fa fa-check-circle download-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
        <div class="content">
            <span
                [i18n]="'df-management.df-transaction.form.model-popup.down-load-button.download-transReport-message'"></span>
        </div>
        <div class="form-group ">
            <button (click)="confirmReportDownload()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isDownReportSuccessPopupModel" class="overlay">
    <div class="download-popup">
        <i class="fa fa-check-circle download-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
        <div class="download-content">
            <span
                [i18n]="'df-management.df-transaction.form.model-popup.down-load-button.download-report-success-message'"></span>
        </div>
        <div class="form-group">
            <button (click)="confirmDownloadReportButton()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isDownloadErrorReport" class="overlay">
    <div class="download-popup">
        <i class="fa fa-check-circle download-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
        <div class="content">
            <span
                [i18n]="'df-management.df-transaction.form.model-popup.down-load-button.download-report-message'"></span>
        </div>
        <div class="form-group">
            <button (click)="confirmDownloadPopup()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isPopupSupressCharges" class="overlay">
    <div class="supress-popup">
        <div class="supress-content">
            <i class="fa fa-check-circle success-button"></i>
            <h4 [i18n]="'df-management.df-transaction.form.model-popup.supress-content.heading'"></h4>

            <span [i18n]="'df-management.df-transaction.form.model-popup.supress-content.content'"></span>
        </div>
        <div class="form-group ">
            <button (click)="supressConfirm()" class="btn btn-i btn-primary btn-lg button" type="submit">
                <span [i18n]="'df-management.df-transaction.form.model-popup.submit-content.button'"></span>
            </button>
        </div>
    </div>
</div>
